function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "6.124 46.862 477.571 400.514",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath0",
    transform: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 447 L 533 447 L 533 0 L 0 0 Z",
    style: {
      fill: "none",
      clipRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.896005, 0, 0, -0.896005, 6.124436, 447.375763)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.7207 6.1543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 205.926 172.446 L 353.247 15.233 L 268.107 224.036 L 448.782 435.946 L 237.984 307.33 L 195.808 416.478 L 135.559 330.307 L 54.224 384.882 L 99.41 226.908 Z",
    style: {
      fill: "rgb(103, 197, 109)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(250.3848 91.5586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 99.007 90.745 L 169.84 8.021 L 128.899 117.889 L 215.772 229.395 L 114.416 161.719 L 94.146 219.149 L 65.182 173.809 L 26.074 202.526 L 47.794 119.4 Z",
    style: {
      fill: "rgb(88, 50, 155)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(250.373 91.5703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 99.007 90.741 L 169.84 8.021 L 128.905 117.89 L 215.771 229.394 L 114.419 161.718 L 94.145 219.149 L 65.18 173.809 L 26.073 202.525 L 47.801 119.4 L 0 0 Z",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      strokeOpacity: 1,
      strokeMiterlimit: 4,
      strokeWidth: "0.663px",
      strokeDashoffset: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 447 L 533 447 L 533 0 L 0 0 Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(293.2002 95.6279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 1.153 2.407 1.537 4.347 1.16 5.832 C 0.781 7.322 -0.167 8.445 -1.692 9.225 C -3.023 9.899 -4.488 10.006 -6.086 9.545 C -7.687 9.084 -9.19 7.699 -10.593 5.395 Z M 4.577 -6.669 L -12.532 2.034 C -14.032 -0.649 -14.441 -2.851 -13.762 -4.541 C -13.083 -6.238 -11.721 -7.605 -9.692 -8.633 C -8.35 -9.32 -6.884 -9.856 -5.293 -10.248 C -3.702 -10.645 -1.98 -10.893 -0.124 -11.006 L -2.355 -14.973 C -4.009 -14.997 -5.707 -14.777 -7.452 -14.329 C -9.19 -13.877 -11.076 -13.14 -13.099 -12.11 C -16.979 -10.143 -19.522 -7.592 -20.722 -4.459 C -21.928 -1.336 -21.479 2.11 -19.374 5.879 L -18.421 7.58 C -16.575 10.869 -13.968 13.129 -10.586 14.342 C -7.204 15.552 -3.514 15.139 0.491 13.104 C 4.305 11.164 6.624 8.61 7.449 5.448 C 8.278 2.278 7.735 -1.022 5.814 -4.453 C 5.08 -5.759 4.671 -6.499 4.577 -6.669",
    style: {
      fill: "rgb(88, 50, 155)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(320.2012 76.6816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 4.395 12.855 C 4.234 13.548 3.886 14.199 3.336 14.801 C 2.785 15.41 1.952 15.884 0.835 16.226 C -0.715 16.71 -2.17 16.469 -3.524 15.505 C -4.873 14.535 -6.113 12.394 -7.255 9.071 L -7.864 7.278 C -8.772 4.624 -9.048 2.65 -8.686 1.337 C -8.325 0.029 -7.374 -0.865 -5.843 -1.337 C -4.796 -1.663 -3.737 -1.684 -2.654 -1.408 C -1.571 -1.136 -0.687 -0.664 0 0 M 5.051 -9.656 L -2.212 -7.405 L -1.19 -3.793 C -2.803 -4.867 -4.299 -5.52 -5.677 -5.749 C -7.054 -5.975 -8.621 -5.814 -10.372 -5.27 C -13.064 -4.436 -15.021 -2.887 -16.244 -0.627 C -17.462 1.632 -17.352 4.871 -15.902 9.107 L -14.984 11.802 C -13.655 15.689 -11.656 18.419 -8.988 19.998 C -6.315 21.586 -3.104 21.787 0.656 20.614 C 1.579 20.331 2.537 19.898 3.531 19.326 C 4.518 18.756 5.275 17.971 5.807 16.985 L 9.049 26.47 L 16.594 24.129",
    style: {
      fill: "rgb(88, 50, 155)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(361.1826 61.1221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L -7.532 1.035 L -7.021 5.223 C -8.118 4.168 -9.538 3.254 -11.29 2.489 C -13.039 1.721 -15.09 1.495 -17.44 1.823 C -19.646 2.122 -21.281 2.992 -22.358 4.431 C -23.429 5.861 -23.726 8.191 -23.233 11.407 L -20.39 30.194 L -12.535 29.112 L -15.287 10.963 C -15.501 9.563 -15.34 8.568 -14.795 8.003 C -14.252 7.432 -13.529 7.09 -12.642 6.965 C -11.508 6.813 -10.433 6.867 -9.415 7.133 C -8.402 7.397 -7.498 7.905 -6.706 8.663 L -3.785 27.907 L 4.069 26.824",
    style: {
      fill: "rgb(88, 50, 155)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(394.1572 62.2393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C -0.313 -0.241 -1.236 -0.631 -2.777 -1.177 C -4.321 -1.714 -5.932 -1.999 -7.61 -2.021 C -12.212 -2.093 -15.89 -1.01 -18.646 1.214 C -21.4 3.442 -22.812 6.819 -22.892 11.355 L -22.909 12.503 C -22.974 16.617 -21.689 19.929 -19.059 22.442 C -16.434 24.957 -12.845 26.253 -8.292 26.316 C -6.493 26.346 -4.867 26.145 -3.411 25.719 C -1.951 25.292 -0.945 24.825 -0.389 24.329 L -0.319 19.539 C -1.04 20.155 -1.993 20.656 -3.183 21.064 C -4.375 21.467 -5.659 21.663 -7.049 21.644 C -9.462 21.61 -11.295 20.757 -12.554 19.102 C -13.809 17.446 -14.411 15.192 -14.37 12.337 L -14.357 11.847 C -14.311 8.646 -13.75 6.388 -12.691 5.074 C -11.627 3.756 -9.934 3.11 -7.622 3.146 C -6.066 3.17 -4.56 3.4 -3.092 3.845 C -1.626 4.294 -0.627 4.732 -0.089 5.17",
    style: {
      fill: "rgb(88, 50, 155)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(418.5703 73.374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L -0.132 0.717 C -0.421 2.319 -1.041 3.472 -1.983 4.182 C -2.929 4.892 -4.171 5.116 -5.714 4.868 C -7.162 4.626 -8.245 4.039 -8.944 3.106 C -9.646 2.172 -9.842 0.848 -9.527 -0.879 L -9.399 -1.601 C -9.072 -3.398 -8.404 -4.528 -7.4 -4.983 C -6.399 -5.439 -5.205 -5.552 -3.816 -5.315 C -2.62 -5.128 -1.621 -4.582 -0.8 -3.695 C 0.016 -2.802 0.283 -1.571 0 0 M 9.152 -7.752 L 1.827 -8.957 L 1.086 -5.445 C 0.684 -6.664 -0.156 -7.739 -1.437 -8.687 C -2.728 -9.634 -4.311 -10.259 -6.198 -10.573 C -9.305 -11.087 -11.794 -10.732 -13.655 -9.509 C -15.518 -8.285 -16.724 -6.166 -17.27 -3.15 L -17.358 -2.684 C -17.895 0.302 -17.251 2.781 -15.412 4.751 C -13.573 6.72 -10.858 8.003 -7.268 8.594 C -6.176 8.77 -5.074 8.794 -3.963 8.666 C -2.853 8.536 -2.005 8.279 -1.437 7.9 L -1.917 10.545 C -2.084 11.468 -2.662 12.178 -3.655 12.674 C -4.654 13.166 -5.956 13.276 -7.56 13.018 C -9.286 12.732 -10.788 12.297 -12.07 11.717 C -13.353 11.132 -14.442 10.485 -15.336 9.789 L -16.146 14.224 C -14.951 14.951 -13.598 15.63 -12.083 16.263 C -10.57 16.897 -8.677 17.399 -6.424 17.77 C -2.799 18.368 0.016 18.033 2.027 16.763 C 4.042 15.488 5.357 13.147 5.979 9.723",
    style: {
      fill: "rgb(88, 50, 155)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(446.0098 94.4697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L -7.074 -2.164 L -2.608 -15.406 C -2.159 -16.749 -1.592 -17.671 -0.913 -18.156 C -0.238 -18.641 0.773 -18.676 2.115 -18.262 C 2.749 -18.066 3.346 -17.825 3.907 -17.546 C 4.463 -17.258 4.961 -16.959 5.403 -16.651 L 6.788 -20.752 C 6.095 -21.315 5.184 -21.846 4.066 -22.349 C 2.95 -22.852 1.825 -23.283 0.702 -23.625 C -1.776 -24.391 -3.993 -24.222 -5.951 -23.147 C -7.908 -22.065 -9.362 -20.097 -10.326 -17.245 L -14.662 -4.388 L -17.914 -5.388 L -19.145 -1.738 L -15.667 -0.474 L -16.04 8.77 L -11.254 10.232 L -8.398 1.751 L -1.319 3.926",
    style: {
      fill: "rgb(88, 50, 155)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(467.6826 78.9043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L -7.274 -3.017 L -18.616 21.833 L -11.338 24.85 Z M -13.667 30.442 C -13.2 29.402 -13.171 28.38 -13.595 27.367 C -14.016 26.351 -14.757 25.628 -15.819 25.191 C -16.865 24.756 -17.926 24.73 -19.003 25.12 C -20.072 25.519 -20.847 26.233 -21.312 27.27 C -21.773 28.279 -21.786 29.283 -21.36 30.303 C -20.929 31.32 -20.195 32.04 -19.149 32.477 C -18.084 32.915 -17.02 32.94 -15.955 32.543 C -14.892 32.146 -14.129 31.449 -13.667 30.442",
    style: {
      fill: "rgb(88, 50, 155)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(486.748 104.0898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L -0.213 0.345 C -2.2 3.465 -4.058 5.306 -5.796 5.859 C -7.528 6.418 -9.125 6.274 -10.579 5.436 C -12.111 4.548 -12.97 3.219 -13.152 1.443 C -13.341 -0.33 -12.49 -2.702 -10.61 -5.658 L -10.391 -6.001 C -8.322 -9.268 -6.48 -11.158 -4.867 -11.69 C -3.253 -12.224 -1.656 -12.033 -0.065 -11.116 C 1.359 -10.288 2.257 -9.059 2.614 -7.422 C 2.975 -5.782 2.105 -3.306 0 0 M 7.403 3.509 C 9.68 -0.076 10.372 -3.493 9.472 -6.754 C 8.581 -10.012 6.239 -12.732 2.455 -14.92 C -1.309 -17.095 -4.951 -17.793 -8.474 -17.025 C -12 -16.255 -14.866 -14.126 -17.078 -10.637 L -18.014 -9.17 C -20.177 -5.759 -20.829 -2.376 -19.971 0.977 C -19.106 4.335 -16.784 7.114 -12.999 9.305 C -9.18 11.503 -5.517 12.176 -2.011 11.325 C 1.494 10.473 4.322 8.356 6.476 4.974",
    style: {
      fill: "rgb(88, 50, 155)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(528.3916 119.1064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L -5.856 -5.109 L -19.332 8.929 C -19.835 9.446 -20.537 9.732 -21.438 9.779 C -22.336 9.828 -23.218 9.473 -24.087 8.715 C -24.92 7.987 -25.493 7.177 -25.802 6.286 C -26.114 5.392 -26.239 4.493 -26.187 3.583 L -12.371 -10.8 L -18.225 -15.909 L -37.422 4.08 L -31.791 9.001 L -28.634 5.924 C -29.118 7.237 -29.106 8.787 -28.597 10.572 C -28.085 12.347 -26.962 13.991 -25.228 15.504 C -23.484 17.029 -21.602 17.704 -19.599 17.525 C -17.587 17.355 -15.547 16.19 -13.477 14.038",
    style: {
      fill: "rgb(88, 50, 155)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.9082 210.5957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 0 -8.626 -3.023 -14.991 -9.06 -19.102 C -15.092 -23.215 -23.49 -25.273 -34.242 -25.273 C -40.391 -25.273 -45.578 -24.926 -49.806 -24.24 C -54.027 -23.552 -57.523 -22.683 -60.272 -21.633 L -60.272 -7.842 C -58.126 -9.076 -54.743 -10.221 -50.142 -11.26 C -45.541 -12.3 -41.018 -12.82 -36.559 -12.82 C -30.301 -12.82 -25.991 -12.025 -23.631 -10.426 C -21.271 -8.832 -20.089 -6.184 -20.089 -2.479 C -20.089 -0.108 -20.941 1.991 -22.644 3.824 C -24.341 5.657 -29.173 8.08 -37.133 11.099 C -43.472 13.542 -48.381 16.659 -51.852 20.447 C -55.323 24.237 -57.055 29.402 -57.055 35.936 C -57.055 42.188 -54.259 47.465 -48.651 51.777 C -43.052 56.088 -35.306 58.244 -25.417 58.244 C -20.628 58.244 -16.316 57.877 -12.484 57.141 C -8.659 56.405 -5.969 55.751 -4.425 55.181 L -4.425 42.921 C -7.658 43.678 -10.881 44.346 -14.087 44.926 C -17.286 45.502 -20.694 45.795 -24.312 45.795 C -29.432 45.795 -33.123 45.023 -35.388 43.486 C -37.648 41.948 -38.777 40.024 -38.777 37.717 C -38.777 34.843 -37.93 32.667 -36.235 31.194 C -34.537 29.722 -29.563 27.549 -21.309 24.674 C -13.626 22.016 -8.15 18.648 -4.892 14.571 C -1.632 10.494 0 5.639 0 0",
    style: {
      fill: "rgb(88, 50, 155)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(125.8843 255.6255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L -18.479 0 L -18.479 -69.151 L -37.77 -69.151 L -37.77 0 L -56.853 0 L -56.853 12.066 L 0 12.066",
    style: {
      fill: "rgb(88, 50, 155)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.2661 217.6973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L -10.633 29.951 L -20.355 0 Z M 29.9 -31.223 L 10.337 -31.223 L 4.07 -11.684 L -24.121 -11.684 L -30.549 -31.223 L -46.238 -31.223 L -17.544 49.995 L 0.361 49.995",
    style: {
      fill: "rgb(88, 50, 155)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(243.2998 244.0996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 2.223 C 0 5.769 -0.98 8.296 -2.932 9.817 C -4.89 11.339 -7.781 12.099 -11.619 12.099 L -17.883 12.099 L -17.883 -9.548 L -12.689 -9.548 C -8.142 -9.548 -4.89 -8.755 -2.932 -7.161 C -0.98 -5.569 0 -3.185 0 0 M 21.296 -57.625 L 2.212 -57.625 C 2.058 -44.564 0.752 -35.236 -1.702 -29.631 C -4.156 -24.034 -8.047 -21.234 -13.376 -21.234 L -17.883 -21.234 L -17.883 -57.625 L -37.168 -57.625 L -37.168 23.592 L -3.726 23.592 C 4.424 23.592 10.196 21.901 13.589 18.519 C 16.984 15.135 18.688 10.981 18.688 6.056 L 18.688 1.632 C 18.688 -3.008 17.215 -6.73 14.275 -9.539 C 11.338 -12.345 6.938 -13.999 1.059 -14.501 C 7.783 -16.399 12.839 -20.616 16.222 -27.15 C 19.606 -33.684 21.296 -43.844 21.296 -57.625",
    style: {
      fill: "rgb(88, 50, 155)",
      fillOpacity: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLogo);
export default __webpack_public_path__ + "static/media/starLogo.03ac529416083e6eae9b5f3ced231d38.svg";
export { ForwardRef as ReactComponent };